import { __assign } from "tslib";
import { IDimension } from "../../models/node";
import { AsyncState, IAction, IAsyncState } from "../action";
import { actionTypes } from "../actions";
var initialState = new AsyncState();
export function dimensions(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return initialState;
        case actionTypes.dataModelNamesLoaded:
            return initialState;
        case actionTypes.loadDataModelNodes:
            return __assign(__assign({}, state), { data: null, isFetching: true, timestamp: new Date() });
        case actionTypes.dimensionsLoaded:
            return __assign(__assign({}, state), action.payload);
        case actionTypes.compatibilityChecked:
            if (action.payload && action.payload.data) {
                return __assign(__assign({}, state), { data: action.payload.data.dimensions });
            }
            return state;
        default:
            return state;
    }
}
